export const MEDTOCHKA_APP_STORE = {
  android: 'https://play.google.com/store/apps/details?id=ru.medtochka',
  ios: 'https://apps.apple.com/ru/app/%D0%BC%D0%B5%D0%B4%D1%82%D0%BE%D1%87%D0%BA%D0%B0/id1591602076',
} as const

export const SLIDE_IMAGE_PATH = {
  mobileDocs: '_v1/pd/screenshots/medtochka/medtochka-app-medcard-add-docs.png',
  mobileSeeDesktop: '_v1/pd/screenshots/medtochka/medtochka-app-medcard-see-desktop.png',
  desktopDocsQr: '_v1/pd/screenshots/medtochka/medtochka-app-medcard-add-docs-qr.png',
  desktopSeeDesktopQr: '_v1/pd/screenshots/medtochka/medtochka-app-medcard-see-desktop-qr.png',
} as const
